var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useState } from "react";
import { useEffect } from "react";
import { getAckowledgement, submitAckowledgement } from "./api/acknowledgement";
import { AonDialog } from "./components/core/AonDialog";
import { UuiLogo, UuiOverlayLoader, UuiSpinner } from "@aonunited/react";
import { AonButton } from "./components/core/AonButton";
import { BUTTON_VARIANT } from "./components/core/AonButton/consts";
import { isInternaluser } from "./api/auth/okta";
import { useNavigate } from "react-router-dom";
import { useErrorStore } from "./store";
import { getApplicationConfig } from "./constants/utilities";
var CheckAcknowledgment = function (props) {
    var internalUser = isInternaluser();
    var application = getApplicationConfig();
    var needsAcknowledgmentCheck = !internalUser && application.applicationId !== 3;
    var _a = useState(false), agreed = _a[0], setAgreed = _a[1];
    var _b = useState(1), dailogState = _b[0], setDailogState = _b[1];
    // Starts true only when we're about to fetch the acknowledgment (external user, non-Guide app),
    // so the dialog below never mounts with opened=true before that fetch flips loading back off -
    // mounting it briefly first triggers a UuiDialog showModal() crash when it unmounts right after.
    var _c = useState(needsAcknowledgmentCheck), loading = _c[0], setLoading = _c[1];
    var _d = useState(false), isError = _d[0], setIsError = _d[1];
    var _e = useState(null), htmlAndEluValues = _e[0], setHtmlAndEluValues = _e[1];
    var _f = useState(false), submitAck = _f[0], setSubmitAck = _f[1];
    var navigation = useNavigate();
    var errorStore = useErrorStore();
    useEffect(function () {
        if (needsAcknowledgmentCheck) {
            fetchAckn();
        }
    }, [internalUser]);
    useEffect(function () {
        var html = document.getElementById("__ackBody__");
        if (html && (htmlAndEluValues === null || htmlAndEluValues === void 0 ? void 0 : htmlAndEluValues.html)) {
            html.innerHTML = htmlAndEluValues === null || htmlAndEluValues === void 0 ? void 0 : htmlAndEluValues.html;
        }
    }, [htmlAndEluValues === null || htmlAndEluValues === void 0 ? void 0 : htmlAndEluValues.html]);
    var fetchAckn = function () { return __awaiter(void 0, void 0, void 0, function () {
        var res, innerHtml, error_1;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _c.trys.push([0, 2, , 3]);
                    setLoading(true);
                    return [4 /*yield*/, getAckowledgement()];
                case 1:
                    res = _c.sent();
                    if (res.data.values.length === 0) {
                        setAgreed(true);
                    }
                    if ((_b = (_a = res.data.values[0]) === null || _a === void 0 ? void 0 : _a.eula) === null || _b === void 0 ? void 0 : _b.text) {
                        innerHtml = res.data.values[0].eula.text;
                        if (innerHtml) {
                            setHtmlAndEluValues({ html: innerHtml, eluId: res.data.values[0].eula.id, eluVersion: res.data.values[0].eula.version });
                        }
                    }
                    setLoading(false);
                    setIsError(false);
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _c.sent();
                    //  setDailogState(0);
                    //errorStore.showError({ message: "Error", code: "500" });
                    //  navigation('/error');
                    //console.log("Eula API error" + error.status);
                    setHtmlAndEluValues({ html: "Something went wrong, If issue persist please contact Support.", eluId: "", eluVersion: NaN });
                    setLoading(false);
                    setIsError(true);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var submitAckn = function () { return __awaiter(void 0, void 0, void 0, function () {
        var error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 4, , 5]);
                    setSubmitAck(true);
                    if (!htmlAndEluValues) return [3 /*break*/, 3];
                    return [4 /*yield*/, submitAckowledgement({
                            eulaId: htmlAndEluValues === null || htmlAndEluValues === void 0 ? void 0 : htmlAndEluValues.eluId,
                            eulaVersion: htmlAndEluValues === null || htmlAndEluValues === void 0 ? void 0 : htmlAndEluValues.eluVersion
                        })];
                case 1:
                    _a.sent();
                    return [4 /*yield*/, fetchAckn()];
                case 2:
                    _a.sent();
                    setSubmitAck(false);
                    _a.label = 3;
                case 3: return [3 /*break*/, 5];
                case 4:
                    error_2 = _a.sent();
                    setSubmitAck(false);
                    setIsError(true);
                    errorStore.showError({ message: "Error", code: error_2.status });
                    navigation('/error');
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var Body = function () {
        return React.createElement("div", { style: { width: "800px" } },
            loading && React.createElement(UuiSpinner, { variant: 'small' }),
            React.createElement("div", { id: "__ackBody__" }));
    };
    var Footer = function () {
        return React.createElement("div", null, isError ? null :
            React.createElement(AonButton, { style: { marginInline: "5px" }, variant: BUTTON_VARIANT.DEFAULT, onClick: submitAckn, disabled: submitAck }, "I Agree"));
    };
    if (loading) {
        return React.createElement(UuiOverlayLoader, { text: "Loading...", show: true });
    }
    else if (internalUser || agreed || application.applicationId === 3) {
        return props.children;
    }
    else {
        return React.createElement("div", null,
            React.createElement(AonDialog, { dismissOnEsc: false, dismissOnOverlay: false, opened: !!dailogState, enableBackgroundScroll: false, header: React.createElement("div", { className: 'header' },
                    React.createElement("div", { className: 'logo_about_dialog' },
                        React.createElement(UuiLogo, null))), body: React.createElement(Body, null), footer: React.createElement(Footer, null) }));
    }
};
export default CheckAcknowledgment;
